<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card class="update-checker-card pa-4" v-bind="$attrs" id="debtor-detail">
      <v-btn @click="handleSubmit(false)" small icon absolute top right>
        <v-icon>close</v-icon>
      </v-btn>
      <p class="primary--text title">
        {{ $t("Внимание") }}
      </p>
      <p class="body" v-html="$t('updateCheckerBody')" />
      <v-btn color="primary" class="mr-1 mb-1" @click="handleSubmit(true)">{{
        $t("updateCheckerConfirmText")
      }}</v-btn>
      <v-btn
        color="primary"
        class="mb-1"
        outlined
        @click="handleSubmit(false)"
        >{{ $t("updateCheckerCancelText") }}</v-btn
      >
    </v-card>
  </v-dialog>
</template>
<script lang="ts">
import UpdateCheckerMixin from "@alseco/spa-update-checker/UpdateCheckerMixin";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  name: "CabinetUpdateChecker",
})
export default class extends Mixins(UpdateCheckerMixin) {}
</script>
<style lang="scss">
.update-checker-card {
  .title {
    @include fontSize(16, 24);
  }

  .body {
    @include fontSize(14, 16);
    color: black;
  }
}
</style>
